import { createContext, useContext, useRef, useState, useCallback } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const Ctx = createContext(null);
export const useConfirm = () => useContext(Ctx);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState(null);
  const [val, setVal] = useState("");
  const resolver = useRef(null);
  const ask = useCallback((opts) => new Promise((res) => {
    resolver.current = res;
    setVal(opts.defaultValue || "");
    setState(opts);
  }), []);
  const api = { confirm: (o) => ask({ ...o, kind: "confirm" }), prompt: (o) => ask({ ...o, kind: "prompt" }) };
  const close = (result) => { resolver.current?.(result); setState(null); };
  return (
    <Ctx.Provider value={api}>
      {children}
      <AlertDialog open={!!state} onOpenChange={(o) => !o && close(state?.kind === "prompt" ? null : false)}>
        <AlertDialogContent className="bg-[var(--panel)] border-[var(--border-strong)] max-w-sm" data-testid="confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-base font-medium">{state?.title}</AlertDialogTitle>
            {state?.body && <AlertDialogDescription className="text-sm text-neutral-400">{state.body}</AlertDialogDescription>}
          </AlertDialogHeader>
          {state?.kind === "prompt" && (
            <input autoFocus className="w-full px-2.5 py-1.5 rounded border text-sm" value={val} onChange={(e) => setVal(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter" && val.trim()) close(val.trim()); }} data-testid="confirm-input" />
          )}
          <AlertDialogFooter>
            <AlertDialogCancel className="btn" data-testid="confirm-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction data-testid="confirm-ok" disabled={state?.kind === "prompt" && !val.trim()}
              className={`btn ${state?.danger ? "bg-[var(--breach)] text-white border-[var(--breach)]" : "btn-primary"}`}
              onClick={() => close(state?.kind === "prompt" ? val.trim() : true)}>{state?.okLabel || (state?.danger ? "Delete" : "OK")}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </Ctx.Provider>
  );
}
